import useOffer from '../../../../hooks/Offers/useOffer'
import useOfferMetaData from '../../../../hooks/Offers/useOfferMetaData'
import { isHotel, isLEHotel } from '../../../../lib/offer/offerTypes'

interface GroupedHotelSearchTileSecondaryOfferState {
  secondaryOffer?: App.HotelOffer | App.HotelOfferSummary
  secondaryOfferMetaData?: App.OfferListMetaData
  fetching: boolean
}

function useGroupedHotelSearchTileSecondaryOffer(
  primaryOffer: App.HotelOffer | App.HotelOfferSummary,
  filters?: App.OfferListFilters,
): GroupedHotelSearchTileSecondaryOfferState {
  const primaryOfferMetaData = useOfferMetaData(primaryOffer.id, filters)
  const secondaryOfferId = primaryOfferMetaData?.secondaryOfferId
  const secondaryOfferMetaData = useOfferMetaData(secondaryOfferId ?? '', filters)

  const [secondaryOffer, fetching, error] = useOffer(secondaryOfferId, { requireSummaryOnly: true })
  const validSecondaryOffer = isHotel(secondaryOffer) && isLEHotel(secondaryOffer) ? secondaryOffer : undefined

  return {
    secondaryOffer: validSecondaryOffer,
    secondaryOfferMetaData,
    fetching: (!!secondaryOfferId && !secondaryOffer && !error) || fetching,
  }
}

export default useGroupedHotelSearchTileSecondaryOffer
